import { FormControlLabel } from '@andritzot/metris-web-ui/inputs/form-control';
import { Switch } from '@andritzot/metris-web-ui/inputs/switch';
import { type Control, Controller } from 'react-hook-form';

import { type FormProps } from './types';

interface ContactMeSwitchProps {
  control: Control<FormProps>;
}

export function ContactMeSwitch({ control }: Readonly<ContactMeSwitchProps>) {
  return (
    <Controller
      name="beContacted"
      control={control}
      render={({ field }) => (
        <FormControlLabel
          label="Contact Me"
          control={<Switch checked={field.value} onChange={(_, val) => val !== null && field.onChange(val)} />}
        />
      )}
    />
  );
}
